export default class Contact {
  constructor() {
    this.form = document.querySelector(".js-contact-form");
    if (!this.form) return;

    this.nameEl = this.form.querySelector(".js-contact-name");
    this.emailEl = this.form.querySelector(".js-contact-email");
    this.msgEl = this.form.querySelector(".js-contact-message");
    this.phoneEl = this.form.querySelector(".js-contact-phone");
    this.statusEl = this.form.querySelector(".js-contact-status");

    this.phoneEl.addEventListener("input", () => {
      this.phoneEl.value = this.phoneEl.value.replace(/[^0-9+]/g, "");
    });

    this.initAutoFill();
    this.bind();
  }

  initAutoFill() {
    const params = new URLSearchParams(window.location.search);
    const productName = params.get('product');

    if (productName) {
      if (this.msgEl) {
        this.msgEl.value = `${productName} ürünü hakkında bilgi almak istiyorum.`;

        const formCard = document.querySelector('.contact-form-card');
        if (formCard) {
          formCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (this.nameEl) {
          setTimeout(() => this.nameEl.focus({ preventScroll: true }), 500);
        }
      }
    }
  }

  bind() {
    this.form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const name = this.nameEl.value.trim();
      const email = this.emailEl.value.trim();
      const message = this.msgEl.value.trim();
      const phone = this.phoneEl.value.trim();

      if (!name || !email || !message || !phone) {
        this.setStatus("Lütfen tüm alanları doldurun.", false);
        return;
      }
      if (!this.isValidEmail(email)) {
        this.setStatus("Lütfen geçerli bir e-posta adresi girin.", false);
        return;
      }
      if (!this.isValidPhone(phone)) {
        this.setStatus("Lütfen geçerli bir telefon numarası girin.", false);
        return;
      }

      try {
        const res = await fetch("/api/contact-requests/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            full_name: name,
            email: email,
            phone: phone,
            message: message,
          }),
        });

        if (res.ok) {
          this.setStatus("Mesajınız başarıyla gönderildi.", true);
          this.form.reset();
        } else {
          const errData = await res.json().catch(() => ({}));
          this.setStatus(
            "Bir hata oluştu. " + (errData.detail || "Lütfen tekrar deneyin."),
            false
          );
        }
      } catch (err) {
        this.setStatus(
          "Sunucuya bağlanılamadı. Lütfen daha sonra deneyin.",
          false
        );
      }
    });
  }

  isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  isValidPhone(v) {
    return /^\+?\d{10,15}$/.test(v);
  }

  setStatus(text, ok = true) {
    if (!this.statusEl) return;
    this.statusEl.textContent = text;
    this.statusEl.classList.remove("--ok", "--err");
    this.statusEl.classList.add(ok ? "--ok" : "--err");
  }
}
